// @flow
import * as React from 'react';
import { Link } from '../../common/components/core';
import LoggedoutActions from '../../main/actions/LoggedoutActions';

type Props = {
  email: ?string,
  onLinkClick: () => void
};

class ScreenResetVerification extends React.PureComponent<Props> {
  _sendResetEmail = () => {
    LoggedoutActions.sendResetEmail(this.props.email);
  };

  render() {
    return (
      <div className="slide2-background">
        <div className="email-sent">
          <div className="verify-logo">
            <img src="/static/images/branch-logos/branch-logo_dark.svg" />
          </div>
          <div className="loggedout--verify-container">
            <div className="loggedout--verify-header">Link sent!</div>
            <img
              className="email-verify-image"
              src="/static/images/email_sent.svg"
            />
            <br />
            <div className="loggedout--verify-text-block-header">
              Check your email
            </div>
            <br />
            <div className="loggedout--verify-text-block">
              We sent an email to <b className="h_fw-600">{this.props.email}</b>{' '}
              with a link to reset the password. If you have not received the
              email after a few minutes, please check your spam folder.
            </div>
            <Link
              onClick={this.props.onLinkClick}
              i13nModel={{ label: 'show slide 1' }}
              testid="try-reset-again"
              className="try-reset-again-link"
            >
              Haven't received the email? Try again.
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default ScreenResetVerification;
